import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from "rxjs/operators";

import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: LoaderService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // 顯示等待中動畫
    this.loaderService.displayLoader(true);

    return next.handle(req).pipe( // .tap((event: HttpEvent<any>) => {
      tap(
        // 如果收到回應

        event =>
          // // 隱藏等待中動畫
          this.loaderService.displayLoader(false),
        error =>
          // 如果發生錯誤時也要記得隱藏等待中動畫
          this.loaderService.displayLoader(false)
      ));
  }

}
